<template>
  <div class="is-small">
    <ul class>
      <li v-for="item in constraint.entries" :key="item" v-html="item"></li>
    </ul>
  </div>
</template>

<script>
import api from "@/api";

export default {
  components: {},
  props: ["input"],
  data() {
    return {
      constraint: {},
    };
  },
  computed: {
    list() {
      var entries = [];
      var c = this.constraint;
      var str = this.$t("cannot-travel-more-than");
      if (c.max_distance_weekday_home) {
        entries.push(str + c.max_distance_weekday_home + this.$t("miles-from-home-venue-on-a-weekday"));
      }
      if (c.max_distance_weekend_home) {
        entries.push(str + c.max_distance_weekend_home + this.$t("miles-from-home-venue-on-a-weekend"));
      }

      if (c.max_distance_weekday_last) {
        entries.push(str + c.max_distance_weekday_last + this.$t("miles-from-last-game-on-a-weekday"));
      }
      if (c.max_distance_weekend_last) {
        entries.push(str + c.max_distance_weekend_last + this.$t("miles-from-last-game-on-a-weekend"));
      }

      if (c.max_time_weekday_home) {
        entries.push(str + c.max_time_weekday_home + this.$t("minutes-from-home-venue-on-a-weekday"));
      }
      if (c.max_time_weekend_home) {
        entries.push(str + c.max_time_weekend_home + this.$t("minutes-from-home-venue-on-a-weekend"));
      }

      if (c.max_time_weekday_last) {
        entries.push(str + c.max_time_weekday_last + this.$t("minutes-from-last-game-on-a-weekday"));
      }
      if (c.max_time_weekend_last) {
        entries.push(str + c.max_time_weekend_last + this.$t("minutes-from-last-game-on-a-weekend"));
      }
      return entries;
    },
  },
  watch: {
    input: function(val) {
      console.log("Input changed", val);
      this.constraint = JSON.parse(JSON.stringify(this.input || {}));
    },
  },
  mounted() {
    this.constraint = JSON.parse(JSON.stringify(this.input || {}));
  },
};
</script>

<style scoped lang="scss"></style>
